export default "__VITE_ASSET__D0GJzfFv__"